import {
    EmailAuthProvider,
    GoogleAuthProvider,
    getAuth,
    sendPasswordResetEmail,
} from 'firebase/auth';
import * as firebaseui from 'firebaseui';
import StyledFirebaseAuth from './components/StyledFirebaseAuth/StyledFirebaseAuth';
import styles from './Landing.module.scss';
import { Button, Input } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { activateSnackbar } from 'store/features/ui';
import { Logo } from 'lib/themes';
import { GeneracMagicHourBlue, GeneracOffWhite } from 'lib/constants';

export function Landing() {
    const dispatch = useDispatch();
    const [resettingPassword, setResettingPassword] = useState(false);
    const [email, setEmail] = useState('');
    const uiConfig: firebaseui.auth.Config = {
        signInOptions: [
            // Sign in with Google.
            { provider: GoogleAuthProvider.PROVIDER_ID },
            // Sign in with email.
            {
                provider: EmailAuthProvider.PROVIDER_ID,
                signInMethod: EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
            },
            // Sign in with Outlook.
            { provider: 'microsoft.com', loginHint: 'login_hint' },
        ],
        signInSuccessUrl: '/',
        signInFlow: 'popup',
    };
    const resetPassword = () => {
        const auth = getAuth();
        sendPasswordResetEmail(auth, email).then(() => {
            setResettingPassword(false);
            dispatch(
                activateSnackbar({
                    message: 'Password reset email sent',
                    severity: 'success',
                })
            );
        });
    };
    const goToResetPasswordScreen = () => {
        setResettingPassword(true);
    };
    const exitPasswordResetScreen = () => {
        setResettingPassword(false);
    };
    const emailChanged = (
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setEmail(e.target.value);
    };

    return (
        <div data-testid="Landing" className={styles.container}>
            <div>
                <div>
                    <Logo islanding="true" className={styles['tank-logo']} />
                </div>
                {!resettingPassword && (
                    <div className={styles.loginBox}>
                        <StyledFirebaseAuth uiConfig={uiConfig} />
                        <Button
                            onClick={goToResetPasswordScreen}
                            variant="contained"
                            sx={{
                                width: '202px',
                                backgroundColor: GeneracOffWhite,
                                color: GeneracMagicHourBlue,
                            }}
                        >
                            Reset Password
                        </Button>
                    </div>
                )}
                {resettingPassword && (
                    <div
                        className={classNames(
                            styles.loginBox,
                            styles.passwordResetBox
                        )}
                    >
                        <div className={styles.resetPasswordHeader}>
                            Reset Password
                        </div>
                        <Input
                            placeholder="Email"
                            autoFocus={true}
                            onChange={emailChanged}
                            value={email}
                            sx={{
                                color: '#000000',
                            }}
                        />
                        <Button
                            variant="contained"
                            sx={{ width: '180px', margin: '2px' }}
                            onClick={resetPassword}
                        >
                            Submit
                        </Button>
                        <Button
                            variant="contained"
                            onClick={exitPasswordResetScreen}
                            sx={{ width: '180px', margin: '2px' }}
                        >
                            Cancel
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
